var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBowl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.638,
    height: 24.767,
    viewBox: "0 0 43.638 24.767",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1385",
    "data-name": "Group 1385",
    transform: "translate(1.232 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M35.436,9.583C33.25,9.342,27.522,9,21.794,9s-11.456.338-13.641.579a32.16,32.16,0,0,0-5.554.978c.346.9,5.31,13.025,6.1,15.25.21.591,1.362.884,2.917,1.121a48.56,48.56,0,0,0,6.07.441c.681.015,2.4.056,4.11.056s3.429-.041,4.111-.056a48.532,48.532,0,0,0,6.069-.441c1.556-.237,2.709-.531,2.918-1.121.788-2.224,5.752-14.348,6.1-15.25A32.132,32.132,0,0,0,35.436,9.583Z",
    transform: "translate(-1.109 -4.663)",
    fill: "none",
    stroke: "#ffa900",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3806",
    "data-name": "Path 3806",
    d: "M42.355,2.837c.115-.237-.262-.442-.978-.613a32.767,32.767,0,0,0-3.795-.584c-4.555-.5-9.37-.595-14.169-.637C22.845,1,20.525,1,19.955,1c-4.8.042-9.614.136-14.169.637a32.767,32.767,0,0,0-3.795.584c-.583.139-.941.3-.992.485",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#ffa900",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBowl);
export default __webpack_public_path__ + "static/media/bowl.a2637b2da5df7d1457ac659c67300919.svg";
export { ForwardRef as ReactComponent };